import React from 'react';

export type BadgeTone = 'success' | 'warning' | 'error' | 'info' | 'accent' | 'neutral';

export interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  size?: 'sm' | 'md';
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  tone = 'neutral',
  dot = false,
  size = 'md',
  children,
  className = ''
}) => {
  const toneClasses: Record<BadgeTone, string> = {
    success: 'bg-success/12 text-success-soft',
    warning: 'bg-warning/12 text-warning-soft',
    error: 'bg-error/12 text-error-soft',
    info: 'bg-info/12 text-info-soft',
    accent: 'bg-accent/14 text-accent-soft',
    neutral: 'bg-neutral border border-base-300 text-neutral-content/80'
  };

  const dotClasses: Record<BadgeTone, string> = {
    success: 'bg-success',
    warning: 'bg-warning',
    error: 'bg-error',
    info: 'bg-info',
    accent: 'bg-accent',
    neutral: 'bg-base-content/40'
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold select-none ${size === 'sm' ? 'gap-[5px] h-[22px] px-2 text-[11px]' : 'gap-1.5 h-6 px-2.5 text-xs'} ${toneClasses[tone]} ${className}`}
    >
      {dot && <span className={`size-1.5 rounded-full shrink-0 ${dotClasses[tone]}`} aria-hidden="true" />}
      <span>{children}</span>
    </span>
  );
};

Badge.displayName = 'Badge';
